export default "__VITE_ASSET__DthmQOz5__"